<template>
	<div class="social-connect">
		<a class="social-btn social-btn--google" @click="socialClickHandler('Google')">SIGN IN WITH GOOGLE</a>

		<!-- Google sign-in confirmation modal -->
		<div v-if="showConfirm" class="social-connect__overlay" role="dialog" aria-modal="true" aria-labelledby="social-confirm-title">
			<div class="social-connect__modal">
				<p id="social-confirm-title" class="social-connect__modal-text">
					You'll be signed in if you have an account, or a new Football Account will be created. Continue?
				</p>
				<div class="social-connect__modal-actions">
					<button class="btn btn--primary" @click="confirmRedirect">Yes, Continue</button>
					<button class="btn btn--secondary" @click="cancelRedirect">Cancel</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { buildAuthorizeUrl } from '../../api/oauthClient';

	export default {
		data() {
			return {
				showConfirm: false,
				pendingSrc: null,
			};
		},

		methods: {
			socialClickHandler(src) {
				this.$emit('socialButtonClick');
				this.pendingSrc = src;
				this.showConfirm = true;
			},

			confirmRedirect() {
				this.showConfirm = false;
				const src = this.pendingSrc;
				this.pendingSrc = null;

				if (window.OAuthConfig && window.OAuthConfig.enabled) {
					buildAuthorizeUrl({ identityProvider: src }).then((url) => {
						window.location.href = url;
					});
				} else {
					const url =
						CognitoHostedInterfaceURL +
						'/oauth2/authorize?identity_provider=' + src +
						'&redirect_uri=' + CognitoAuthRedirectURL +
						'&response_type=TOKEN&scope=openid%20aws.cognito.signin.user.admin' +
						'&client_id=' + CognitoClientIdPlayfootball;

					window.location.href = url;
				}
			},

			cancelRedirect() {
				this.showConfirm = false;
				this.pendingSrc = null;
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "~sass/_config.scss";
	@import "~sass/_variables.scss";
	@import "~sass/mixins/_media-query.scss";

	.social-connect {
		display: flex;
		justify-content: center;
		margin-bottom: 40px;

		@include maxq(mobile) {
			flex-wrap: wrap;
		}
	}

	.social-connect__overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	}

	.social-connect__modal {
		background: #fff;
		border-radius: 8px;
		padding: 32px;
		max-width: 420px;
		width: 90%;
		text-align: center;
	}

	.social-connect__modal-text {
		font-size: 16px;
		line-height: 1.5;
		margin-bottom: 24px;
		color: #181818;
	}

	.social-connect__modal-actions {
		display: flex;
		gap: 12px;
		justify-content: center;

		.btn {
			min-width: 120px;
		}
	}
</style>
